import * as React from 'react'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { mtc } from '@/styles'
import { Icon } from '../icon'
import { cardStyles, iconStyles } from './styles'

export enum CardColors {
  LEVEL_0 = 'level0',
  LEVEL_1 = 'level1',
  LEVEL_2 = 'level2',
  PRIORITY = 'priority',
  EMPHASIS = 'emphasis',
  BRAND = 'brand',
  SUCCESS = 'success',
  WARNING = 'warning',
  DANGER = 'danger',
  GREEN = 'green',
}

interface ICardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
  color?: CardColors
  className?: string
  dismissible?: boolean
  onClose?: () => void
  permanentDismissalKey?: string
}

export const Card = React.forwardRef<HTMLDivElement, ICardProps>(
  (
    {
      children,
      className,
      color,
      onClose = () => {},
      dismissible = false,
      permanentDismissalKey,
      ...props
    },
    ref
  ) => {
    const [visible, setVisible] = React.useState(
      permanentDismissalKey
        ? !localStorage.getItem(permanentDismissalKey)
        : true
    )

    const handleClose = () => {
      setVisible(false)

      if (permanentDismissalKey) {
        localStorage.setItem(permanentDismissalKey, 'true')
      }

      onClose()
    }

    if (!visible) return null

    return (
      <div
        ref={ref}
        className={mtc(cardStyles({ color }), className)}
        {...props}
      >
        {dismissible && (
          <Icon
            className={mtc(iconStyles())}
            color="text-neutral-500"
            icon={regular('times')}
            id="dismiss-icon"
            onClick={handleClose}
          />
        )}

        {children}
      </div>
    )
  }
)

Card.displayName = 'Card'
